import { render, staticRenderFns } from "./zhuanbing-scale.vue?vue&type=template&id=030d2135&scoped=true&"
import script from "./zhuanbing-scale.vue?vue&type=script&lang=ts&"
export * from "./zhuanbing-scale.vue?vue&type=script&lang=ts&"
import style0 from "./zhuanbing-scale.vue?vue&type=style&index=0&id=030d2135&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d2135",
  null
  
)

export default component.exports